import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "./defaultStyles.css"

// import Theme1Index from "./theme-1/theme-1-index"
// import "./theme-1/theme-1.css"

import Theme2Index from "./theme-2/theme-2-index"
import "./theme-2/theme-2.css"

const IndexPage = () => (
  <Layout>
    <SEO
      title="Home"
      keywords={[`gatsby`, `application`, `react`, `addison schultz`]}
    />
    <Theme2Index />
  </Layout>
)

export default IndexPage
